import ValueLineChart, { type ValuePoint } from './ValueLineChart';

interface NonMetalContractValueData {
    readonly date: string;
    readonly value: number;
}

interface NonMetalContractValueChartProps {
    readonly data: readonly NonMetalContractValueData[];
    readonly loading?: boolean;
    readonly referenceValue?: number;
    readonly currency?: 'EUR' | 'LEI';
}
function NonMetalContractValueChart({
    data,
    loading = false,
    referenceValue,
    currency,
}: NonMetalContractValueChartProps): JSX.Element {
    const chartData: ValuePoint[] = data.map(d => ({ date: d.date, value: d.value ?? 0 }));
    return (
        <ValueLineChart
            data={chartData}
            loading={loading}
            referenceValue={referenceValue}
            seriesNameKey="statistics.charts.nonMetalContractValue"
            seriesNameFallback="Non-Metal Contract Value"
            color="#722ed1"
            currency={currency}
        />
    );
}

export default NonMetalContractValueChart;
